/**
 * Next.js image imports return a `StaticImageData` object
 * ({ src, height, width, blurDataURL }), while many callers in this codebase
 * (mapbox `loadImage`, CSS `url(...)`, template-string `<img src="${...}">`,
 * etc.) expect a plain string URL. This helper accepts either shape and
 * returns a string URL.
 */
export const imageSrc = (asset) =>
	asset && typeof asset === 'object' && 'src' in asset ? asset.src : asset;
